import React from 'react';
import { Slide, Zoom } from "react-awesome-reveal";
import {
  AiFillGithub,
  AiFillLinkedin,
} from 'react-icons/ai';
import { SiUpwork } from "react-icons/si";

const SocialProfiles = () => {
  return (
    <>
      <div className="profiles">
        <Slide direction="left">
          <h1>Check my profiles</h1>
        </Slide>
        <div className="icons">
          <Zoom>
            <span>
              <a
                title="github"
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/faizan-2022"
              >
                <AiFillGithub />
              </a>
            </span>
          </Zoom>
          <Zoom>
            <span>
              <a
                title="linkedin"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/muhammad-faizan-341186237/"
              >
                <AiFillLinkedin />
              </a>
            </span>
          </Zoom>
          <Zoom>
            <span>
              <a
                title="upwork"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.upwork.com/freelancers/~01524beaf8588b6588?mp_source=share"
              >
                <SiUpwork />
              </a>
            </span>
          </Zoom>
        </div>
      </div>
    </>
  );
};

export default SocialProfiles;
